import React, { useState } from 'react';
import DropdownButton from '../DropdownButton';
import DropdownOption from '../DropdownOption';
import EditEmailModal from './EditEmailModal';

const setAsPrimaryOption = (isVerified, isPrimary, handlePrimary) => {
  return isVerified && !isPrimary ? (
    <DropdownOption
      text="Set as primary"
      key="setAsPrimary"
      onClick={handlePrimary}
    />
  ) : null;
};

const editEmailOption = (isVerified, openEditEmailModal) => {
  return isVerified ? (
    <DropdownOption text="Edit" key="editEmail" onClick={openEditEmailModal} />
  ) : null;
};

const resendConfirmationOption = (isVerified, handleResend, useOtpFlow) => {
  return !isVerified ? (
    <DropdownOption
      text={useOtpFlow ? 'Confirm email' : 'Resend confirmation'}
      key="resendConfirmation"
      onClick={handleResend}
    />
  ) : null;
};

const deleteOption = (isPrimary, handleDelete) => {
  return !isPrimary ? (
    <DropdownOption text="Delete" key="deleteEmail" onClick={handleDelete} />
  ) : null;
};

const UpdateEmailDropdown = ({
  email,
  handlePrimary,
  handleResend,
  handleDelete,
  isFetching,
  useOtpFlow,
}) => {
  const [isEditEmailModalOpen, setIsEditEmailModalOpen] = useState(false);

  const openEditEmailModal = () => {
    setIsEditEmailModalOpen(true);
  };

  return (
    <>
      <DropdownButton
        ariaLabel="Update email options"
        isFetching={isFetching}
        dropdownOptions={[
          setAsPrimaryOption(email.isVerified, email.isPrimary, handlePrimary),
          editEmailOption(email.isVerified, openEditEmailModal),
          resendConfirmationOption(email.isVerified, handleResend, useOtpFlow),
          deleteOption(email.isPrimary, handleDelete),
        ]}
      />
      {isEditEmailModalOpen && (
        <EditEmailModal
          email={email}
          closeModal={() => setIsEditEmailModalOpen(false)}
          isOpen={isEditEmailModalOpen}
        />
      )}
    </>
  );
};

export default UpdateEmailDropdown;
